import { Button, Icon, Input, message } from 'antd'
import Highlighter from 'react-highlight-words'
import imageCompression from 'browser-image-compression'
import React from 'react'
import axios from 'axios'
import { isNull } from 'lodash'

export const getColumnSearchProps = (
  dataIndex,
  searchInput,
  searchText,
  handleSearch,
  handleReset
) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={(node) => {
          searchInput.current = node
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => handleSearch(selectedKeys, confirm)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm)}
        icon="search"
        size="small"
        style={{ width: 90, marginRight: 8 }}>
        Search
      </Button>
      <Button
        onClick={() => handleReset(clearFilters)}
        size="small"
        style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: (filtered) => (
    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
  ),
  onFilter: (value, record) =>
    record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: (visible) => {
    if (visible) {
      setTimeout(() => searchInput.current.select())
    }
  },
  render: (text) => (
    <Highlighter
      highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
      searchWords={[searchText]}
      autoEscape
      textToHighlight={text && text.toString()}
    />
  )
})

export function beforeUpload(file, setFile) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }

  if (setFile) {
    setFile(file)
  }

  return false
}

export function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export async function compressFile(file) {
  const options = {
    maxSizeMB: 0.8,
    // maxWidthOrHeight: 256,
    useWebWorker: false
  }

  const compressedFile = await imageCompression(file, options)
  return new File([compressedFile], compressedFile.name, {
    type: compressedFile.type
  })
}

export function validateUploadedImage(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }
  return false
}

export async function uploadBrandActivityImage(file) {
  try {
    const formData = new FormData()
    formData.append('image', await compressFile(file))
    const token = localStorage.getItem('user-token')
    const res = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/brand-activity/image`,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: !isNull(token) ? token : ''
        }
      }
    )

    return res.data
  } catch (err) {
    return null
  }
}

export async function uploadBarcodeRecycleImage(file) {
  try {
    const formData = new FormData()
    formData.append('image', await compressFile(file))
    const token = localStorage.getItem('user-token')
    const res = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/barcode/admin-recycle-image`,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: !isNull(token) ? token : ''
        }
      }
    )

    return res.data
  } catch (err) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/services.js